// extracted by mini-css-extract-plugin
module.exports = {"content":"Spoiler_content__-lbbz","show":"Spoiler_show__3I-Fa","shadyCheckbox":"Spoiler_shadyCheckbox__1VNSt"};